/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_OctoberInputs */

const he_month_october = /** @type {(inputs: Month_OctoberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אוקטובר`)
};

const en_month_october = /** @type {(inputs: Month_OctoberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`October`)
};

/**
* | output |
* | --- |
* | "October" |
*
* @param {Month_OctoberInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_october = /** @type {((inputs?: Month_OctoberInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_OctoberInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_october(inputs)
	return en_month_october(inputs)
});